import { createFileRoute } from '@tanstack/react-router';

import { agreementSearch, collectionAgreementScreen, loadCollectionMessages, loadCollectionScreens } from '@/modules/collection/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';

export const Route = createFileRoute('/_app/gestao-carteira/recuperacao/acordos/$agreementId')({
  validateSearch: agreementSearch,
  staticData: { screen: collectionAgreementScreen },
  loader: () => loadCollectionMessages(),
  component: lazyScreen(loadCollectionScreens, 'CollectionAgreementRouteScreen'),
});
